import { DialogContentText, useTheme, useMediaQuery } from '@mui/material';
import { memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { PmiDialog } from 'shell/components/shared/dialog';
import { PmiDialogContent } from 'shell/components/shared/dialog/content';
import { PmiDialogTitle } from 'shell/components/shared/dialog/title';

interface DeleteAlertModalComponentProps {
  open: boolean;
  onClose: (open?: boolean) => void;
  onYes: (open?: boolean) => void;
  onNo: (open?: boolean) => void;
  title: string;
  message: string;
  yesError?: boolean;
  labelYes?: string;
  labelNo?: string;
}

const DeleteAlertModalComponent = ({
  open,
  onClose,
  onYes,
  onNo,
  title,
  message,
  yesError = false,
  labelYes = 'Si',
  labelNo = 'No',
}: DeleteAlertModalComponentProps): React.ReactElement => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));

  return open ? (
    <PmiDialog
      open={open}
      fullScreen={fullScreen}
      onClose={() => onClose(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <PmiDialogTitle id="alert-dialog-title" color="white" backgroundColor="cdmBrand">
        {title}
      </PmiDialogTitle>
      <PmiDialogContent>
        <DialogContentText id="alert-dialog-description" color="grey">
          {message}
        </DialogContentText>
      </PmiDialogContent>
      <div className="pmi-d-flex pmi-justify-content-end pmi-pb-3 pmi-px-3">
        <div className="pmi-mr-3 pmi-pr-1" style={{ width: 'auto' }}>
          <PmiButton
            fullWidth
            onClick={() => onYes(false)}
            variant="outlined"
            color={yesError ? 'cdmBrand' : 'primary'}
          >
            {labelYes}
          </PmiButton>
        </div>
        <div style={{ width: 'auto' }}>
          <PmiButton
            fullWidth
            onClick={() => onNo(false)}
            variant="outlined"
            color={yesError ? 'primary' : 'cdmBrand'}
          >
            {labelNo}
          </PmiButton>
        </div>
      </div>
    </PmiDialog>
  ) : (
    <></>
  );
};

DeleteAlertModalComponent.displayName = 'Delete Alert Modal component';

const DeleteAlertModal = memo(DeleteAlertModalComponent);

export default DeleteAlertModal as typeof DeleteAlertModalComponent;
